import React from 'react';
import { X, Wallet, CheckCircle2, AlertCircle, PieChart } from 'lucide-react';

export default function ContaPagarTotal({ data, onClose }) {
  const formatBRL = (val) => 
    Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const aReceber = data?.aReceberMes || 0;
  const recebido = data?.recebidoMes || 0;

  const saldoEmAberto = recebido - aReceber ;
  const percentual = recebido > 0 ? ((aReceber  / recebido )*100 ).toFixed(0) : 0;  
  

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Cabeçalho */}
        <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
          <div className="flex items-center gap-2 text-yellow-500 font-bold tracking-widest text-xs uppercase">
            <Wallet size={18} />
            <span>Detalhamento Financeiro Recebimento (Mês)</span>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Conteúdo */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic">Previsão Total a Receber</p>
            <p className="text-white text-2xl font-mono font-bold">{formatBRL(recebido)}</p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <div className="flex justify-between items-center mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic">Total Recebido</p>
              <CheckCircle2 size={14} className="text-green-500" />
            </div>
            <p className="text-green-400 text-2xl font-mono font-bold">{formatBRL(saldoEmAberto)}</p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex justify-between items-center mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic">Saldo em Aberto</p>
              <AlertCircle size={14} className="text-blue-500" />
            </div>
            <p className="text-blue-400 text-2xl font-mono font-bold">{formatBRL(aReceber)}</p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic">Eficiência de Recebimento</p>
            <div className="flex items-end gap-2">
               <p className="text-white text-2xl font-mono font-bold">{percentual}%</p>
               <div className="flex-1 bg-gray-900 h-2 rounded-full mb-2 overflow-hidden">
                  <div 
                    className="bg-yellow-500 h-full shadow-[0_0_8px_#eab308]" 
                    style={{ width: `${percentual}%` }}
                  />
               </div>
            </div>
          </div>
        </div>

        {/* Rodapé */}
        <div className="p-4 bg-[#0d1117] text-right border-t border-gray-800">
          <button 
            onClick={onClose}
            className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-2 px-8 rounded transition-all uppercase tracking-widest shadow-lg"
          >
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  );
}